<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="ch2" epub:type="chapter" role="doc-chapter">
<header>
<h1 class="CT" id="ch2"><samp><span aria-label="11" id="pg_11" role="doc-pagebreak"><span class="Veneer_Clean_Reg_29">BASICS</span></span></samp></h1>
</header>
<p class="Anleser"><samp><span class="Born_Ready_Slanted_Regular_11">Other tools you might need.</span></samp></p>
<section epub:type="division">
<h2 class="H1"><samp><span class="Veneer_Two_Regular_218">MECHANICAL PENCIL</span></samp></h2>
<figure class="IMG"><img alt="" height="450" src="images/pg11-1.jpg"/></figure>
</section>
<section epub:type="division">
<h2 class="H1"><samp><span class="Veneer_Two_Regular_218">NORMAL PENCIL (HARDNESS B RECOMMENDED)</span></samp></h2>
<figure class="IMG"><img alt="" height="306" src="images/pg11-2.jpg" width="136"/></figure>
</section>
<section epub:type="division">
<h2 class="H1"><samp><span class="Veneer_Two_Regular_218">PENCIL SHARPENER</span></samp></h2>
<figure class="IMG"><img alt="" height="277" src="images/pg11-3.jpg" width="330"/></figure>
</section>
<section epub:type="division">
<h2 class="H1"><samp><span aria-label="12" id="pg_12" role="doc-pagebreak"><span class="Veneer_Two_Regular_218">MIXING PALETTE</span></span></samp></h2>
<figure class="IMG"><img alt="" height="321" src="images/pg12-1.jpg" width="320"/></figure>
<p class="TNI"><samp>Often the palette that comes in the paint box will be sufficient. If you mix a lot, keep hold of jar lids to use as mini paint-mixing dishes.</samp></p>
<figure class="IMG"><img alt="" height="265" src="images/pg12-2.jpg" width="467"/></figure>
</section>
<section epub:type="division">
<h2 class="H1"><samp><span class="Veneer_Two_Regular_218">BRUSHES</span></samp></h2>
<p class="TNI"><samp>At the start you'll probably find that just three brushes will be sufficient: small, medium and large.</samp></p>
<figure class="IMG"><img alt="" height="510" src="images/pg12-3.jpg" width="190"/></figure>
</section>
<section epub:type="division">
<h2 class="H1"><samp><span aria-label="13" id="pg_13" role="doc-pagebreak"><span class="Veneer_Two_Regular_218">WATER GLASSES</span></span></samp></h2>
<p class="TNI"><samp>It’s best to have two glasses: one for washing out your brushes, and one with clean water to work with.</samp></p>
<figure class="IMG"><img alt="" height="347" src="images/pg13-1.jpg" width="228"/></figure>
</section>
<section epub:type="division">
<h2 class="H1"><samp><span class="Veneer_Two_Regular_218">TISSUES</span></samp></h2>
<figure class="IMG"><img alt="" height="392" src="images/pg13-2.jpg" width="354"/></figure>
</section>
<section epub:type="division">
<h2 class="H1"><samp><span class="Veneer_Two_Regular_218">WOODEN BOARD</span></samp></h2>
<p class="TNI"><samp>If you don't have a special place to paint, this is a sensible alternative to stretching your paper directly on the kitchen table (see <span href="#/xhtml/chapter4" title="Link target outside of Sample">Preparation</span>)! It allows you the freedom to move your painting at any time and you don't have to quit just because something else is happening at the table. You can simply set the board aside.</samp></p>
<figure class="IMG"><img alt="" height="499" id="fig2" src="images/pg13-3.jpg" width="314"/></figure>
</section>
<section epub:type="division">
<h2 class="H1"><samp><span aria-label="14" id="pg_14" role="doc-pagebreak"><span class="Veneer_Two_Regular_218">WATERCOLOR PAPER</span></span></samp></h2>
<figure class="IMG"><img alt="" height="450 " id="fig3" src="images/pg14-1.jpg"/></figure>
</section>
<section epub:type="division">
<h2 class="H1"><samp><span class="Veneer_Two_Regular_218">ERASER</span></samp></h2>
<figure class="IMG"><img alt="" height="140" id="fig4" src="images/pg14-2.jpg" width="250"/></figure>
</section>
<section epub:type="division">
<h2 class="H1"><samp><span class="Veneer_Two_Regular_218">STICKY TAPE AND/OR WASHI TAPE OR MASKING TAPE</span></samp></h2>
<p class="TNI"><samp>These materials are sufficient as an alternative to stretching for small illustrations that don’t need a lot of water.</samp></p>
<figure class="IMG"><img alt="" height="386" src="images/pg14-3.jpg" width="360"/></figure>
</section>
<section epub:type="division">
<h2 class="H1"><samp><span aria-label="15" id="pg_15" role="doc-pagebreak"><span class="Veneer_Two_Regular_218">LITTLE SPONGES</span></span></samp></h2>
<figure class="IMG"><img alt="" height="367" src="images/pg15-1.jpg" width="358"/></figure>
</section>
<section epub:type="division">
<h2 class="H1"><samp><span class="Veneer_Two_Regular_218">TACKS</span></samp></h2>
<figure class="IMG"><img alt="" height="330" src="images/pg15-2.jpg" width="362"/></figure>
</section>
<section epub:type="division">
<h2 class="H1"><samp><span class="Veneer_Two_Regular_218">BULLDOG CLIPS</span></samp></h2>
<figure class="IMG-NOBOT"><img alt="" height="312" src="images/pg15-3.jpg" width="360"/></figure>
</section>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?7eed3224